export default {
    blacklist: 'Blacklist',
    createBlacklist: 'Create New Blacklist',
    blacklistLists: 'Blacklist Lists',
    blacklistActivity: 'Blacklist Activity',
    blacklistName: 'Blacklist Name',
    dateCreate: 'Date Create',
    status: 'Status',
    action: 'action',
    search: 'Search',
    activityLog: 'Activity Log',
    viewBlacklistProfile: 'View Blacklist Profile',
    profile: 'Profile',
    name: 'Name',
    blacklistReason: 'Blacklist reason',
    deleteBlacklist: 'Delete blacklist',
    wantToDelete: 'Are you sure you want to delete',
    congratulation: 'Congratulation',
    blacklistIsDeleted: 'Blacklist is deleted',
    date: 'Date',
    detectTime: 'Detect Time',
    image: 'Image',
    location: 'Location',
    temperatureShort: 'Temp',
    somethingWrong: 'Something went wrong',
    exportPDF: 'Export PDF',
    exportExcel: 'Export Excel',
    searchText: 'Search by Blacklist name'
}
